/*
 * Vertical histogram — discrete bins, each rendered as a column.
 *
 * Bin tone (red/amber/green) is opt-in per bin so the adoption-confidence
 * histogram can show its risk gradient without affecting the tax bins.
 */

import type { HistogramBin } from '../aggregate';

const TONE_CLASS: Record<NonNullable<HistogramBin['tone']>, string> = {
  error: 'histo-bar--error',
  warn: 'histo-bar--warn',
  success: 'histo-bar--success',
};

interface HistogramProps {
  bins: HistogramBin[];
  ariaLabel?: string;
}

export function Histogram({ bins, ariaLabel }: HistogramProps) {
  const max = Math.max(1, ...bins.map((b) => b.count));
  return (
    <div
      className="histo"
      style={{ gridTemplateColumns: `repeat(${bins.length}, 1fr)` }}
      role="img"
      aria-label={ariaLabel}
    >
      {bins.map((b) => {
        const heightPct = (b.count / max) * 100;
        const toneClass = b.tone ? TONE_CLASS[b.tone] : '';
        return (
          <div className="histo-col" key={b.label}>
            <div
              className={`histo-bar ${toneClass}`.trim()}
              style={{ height: `${heightPct}%` }}
            >
              {b.count > 0 && <div className="histo-bar__count">{b.count}</div>}
            </div>
            <div className="histo-label">{b.label}</div>
          </div>
        );
      })}
    </div>
  );
}
